import { toNumber } from 'lodash-es'

const getSupportConfigFromSupportConfigsAndCheck = (
  supportConfigs: SupportConfig[],
  check: SupportCompressionStructuralCheck | SteelCompressionCheck,
  supportConfigToCheckRelPositionTolerance = 0.0001,
): { supportConfig: SupportConfig; supportConfigIndex: number } | null => {
  if (!supportConfigs.length) {
    return null
  }

  const checkPosition = toNumber(check.relative_position)

  let nearestIndex = -1
  let smallestDistance = Infinity

  // See here why we have to do this: https://app.clickup.com/t/2590559/MDG-3506?comment=90150108322599&threadedComment=90150108328170
  supportConfigs.forEach((config, index) => {
    const configPosition = toNumber(config.relative_position)
    const distance = Math.abs(configPosition - checkPosition)

    if (distance < smallestDistance) {
      smallestDistance = distance
      nearestIndex = index
    }
  })

  if (nearestIndex === -1) {
    return null
  }

  if (smallestDistance > supportConfigToCheckRelPositionTolerance) {
    alert(
      'Achtung! Es könnte sich um eine falsche Auflagerkonfiguration handeln (Element: ' +
        check.element_guid +
        ', Check: ' +
        check.check_type +
        ', Toleranz: ' +
        supportConfigToCheckRelPositionTolerance +
        '), das sollte kurz von einem DEV gecheckt werden. Die Toleranz kann in der App-Konfiguration angepasst werden.',
    )
  }

  const supportConfig = supportConfigs[nearestIndex]

  return {
    supportConfig,
    supportConfigIndex: nearestIndex,
  }
}

export default getSupportConfigFromSupportConfigsAndCheck
